import React from "react";
import { VehicleModel, CmsTab } from "../models/ServicePlanModels";
import { observer } from "mobx-react";
import ImgLazyLoad from "../../ImgLazyLoad";

export interface ServicePlanModelSelectorProps {
  vehicleModels?: VehicleModel[];
  handleModelChange: Function;
  selectedModel: string;
  // New BlockList-driven props — when provided these take precedence
  cpsTabs?: CmsTab[] | null;
  selectedTabId?: string | null;
  onTabChange?: (tab: CmsTab) => void;
}

const ServicePlanModelSelector: React.SFC<ServicePlanModelSelectorProps> =
  observer((props) => {
    // ── BlockList-driven tab rendering ──────────────────────────────────────
    if (props.cpsTabs && props.cpsTabs.length > 0 && props.onTabChange) {
      return (
        <div className="service-plan">
          {props.cpsTabs.map((tab) => (
            <div
              key={tab.tabId}
              className="sp-model col-lg-2 col-width col-md-2 col-sm-3 col-xs-4"
            >
              <a
                href="#"
                className={
                  tab.tabId !== props.selectedTabId
                    ? "selected-model"
                    : "success-checkmark"
                }
                onClick={(e) => {
                  e.preventDefault();
                  props.onTabChange!(tab);
                }}
              >
                <div className="img-wrapper">
                  <ImgLazyLoad src={tab.cpsModelImage} alt="Model image" />
                </div>
                {tab.tabName ? (
                  <div
                    className="sp-model-name"
                    dangerouslySetInnerHTML={{ __html: tab.tabName }}
                  />
                ) : (
                  <div className="sp-model-name">
                    <p><span>{tab.modelId}</span></p>
                  </div>
                )}
              </a>
            </div>
          ))}
        </div>
      );
    }

    // ── Legacy cpsModels rendering (unchanged) ─────────────────────────────
    return (
      <div className="service-plan">
        {props.vehicleModels.map((model, i) => {
          return (
            <div
              key={i}
              className="sp-model col-lg-2 col-width col-md-2 col-sm-3 col-xs-4"
            >
              <a
                href="#"
                className={
                  model.modelID.toLocaleLowerCase() !==
                  props.selectedModel.toLocaleLowerCase()
                    ? "selected-model"
                    : "success-checkmark"
                }
                onClick={(e) => {
                  props.handleModelChange(e, model);
                }}
              >
                <div className="img-wrapper">
                  <ImgLazyLoad src={model.cpsModelImage} alt="Model image" />
                </div>
                {model.modelDisplayName ? (
                  <div
                    className="sp-model-name"
                    dangerouslySetInnerHTML={{
                      __html: model.modelDisplayName,
                    }}
                  />
                ) : (
                  <div className="sp-model-name">
                    <p>
                      <span>{model.name}</span>
                    </p>
                  </div>
                )}
              </a>
            </div>
          );
        })}
      </div>
    );
  });

export default ServicePlanModelSelector;
